export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=40890baf5a7c07d96e55d30f3b0b8da993f7f9cc33&name=revalidateCommunity!'